 
import React from 'react';
import CourseTimeline from '../../components/CourseTimeline/CourseTimeline';
import CourseDetailedDescription from '../../components/CourseDetailedDescription/CourseDetailedDescription';
import PricingSection from '../../sections/PricingSection/PricingSection';
import courseImage from '../../assets/Images/bg/3.png';
import { useNavigate } from 'react-router-dom';
import FAQ from './../../components/FAQ/FAQ'
import { generalFAQ } from './../../data/faqMain' 
import './About.css';

const About: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="about-container">
      <CourseDetailedDescription
        image={courseImage}
        date="October 18th, 2024"
        title="Course Title can be longer here"
        description="Lorem ipsum dolor sit amet consectetur. Diam elit aliquam senectus semper accumsan tortor scelerisque massa. Sagittis magna porta tristique ac leo a. Nulla sit tincidunt sociis suspendisse. Fermentum blandit velit at auctor. 

Facilisis fames pulvinar ornare eleifend. Montes tempor facilisi faucibus semper eu platea. Eros orci nulla lorem justo imperdiet viverra vulputate. In nisi morbi lacus aliquam. Facilisis ut diam elementum gravida felis et proin felis rutrum. Ut eleifend vel quis tellus lorem ultrices mattis. Ipsum elit aenean semper laoreet risus arcu molestie id aliquet. 

"
        onBack={() => navigate('/courses')}
      />
      <CourseTimeline />
      <PricingSection/>
      <FAQ data={generalFAQ}/>
    </div>
  );
};

export default About;
